import getStatus from './status';

export default {
  getStatus,
};
